module.exports = __webpack_public_path__ + "static/026.thumb-d334c3f86e8add79be592b244ba6020c.jpg";